import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  linkedSummary: {
    color: theme.palette.partnerGreen.dark,
    fontWeight: theme.typography.fontWeightMedium,
  },
}))

export default styles
